import type { SVGProps } from 'react';

const SvgPlayerPlay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20.5 11.13 7.91 3.87c-.67-.38-1.5.1-1.5.87v14.54c0 .77.83 1.25 1.5.87l12.59-7.27a.996.996 0 0 0 0-1.73z"
    />
  </svg>
);
export default SvgPlayerPlay;
